import React from 'react'
import { connect } from 'react-redux'
import Button from '@material-ui/core/Button'
import * as actions from '../../store/actions'

function ButtonAddInfo({
  label,
  structure,
  sIndex,
  onAddDetailInfo,
  variant,
  handleAdd,
}) {
  return (
    <Button
      variant={variant || 'contained'}
      color="primary"
      onClick={
        handleAdd
          ? () => handleAdd(structure, sIndex)
          : () => onAddDetailInfo(structure, sIndex)
      }
    >
      {label}
    </Button>
  )
}

const mapDispatchToProps = dispatch => ({
  onAddDetailInfo: (structure, sIndex) => {
    return dispatch(actions.addDetailInfo(structure, sIndex))
  },
})

export default connect(
  null,
  mapDispatchToProps,
)(ButtonAddInfo)
